import { ReactElement } from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  ArcElement,
  Filler as ChartFiller,
  Title as ChartTitle,
  Tooltip as ChartTooltip,
  Legend as ChartLegend,
} from 'chart.js';

import { useTypePartnerCompany } from '~hooks/useTypePartnerCompany';

import ReportsVisitsSectionChartVisitsPerDay from './VisitsPerDay';
import ReportsVisitsSectionChartsPunctualityOfVisits from './PunctualityOfVisits';
import ReportsVisitsSectionChartsReasonsForIncompleteVisits from './ReasonsForIncompleteVisits';
import ReportsVisitsSectionChartsFirstVisitDeliveries from './FirstVisitDeliveries';
// eslint-disable-next-line max-len
import ReportsVisitsSectionChartsHistoricalDemandForRoutedOrders from './HistoricalDemandForRoutedOrders';
import {
  ReportsVisitsSectionChartsContainer,
  ReportsVisitsSectionChartsSubContainer,
} from './styles';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  ArcElement,
  ChartFiller,
  ChartTitle,
  ChartTooltip,
  ChartLegend,
);

const ReportsVisitsSectionCharts = (): ReactElement => {
  const { isCarrier } = useTypePartnerCompany();

  return (
    <ReportsVisitsSectionChartsContainer>
      <ReportsVisitsSectionChartVisitsPerDay />

      {isCarrier && (
        <>
          <ReportsVisitsSectionChartsPunctualityOfVisits />

          <ReportsVisitsSectionChartsSubContainer>
            <ReportsVisitsSectionChartsFirstVisitDeliveries />

            <ReportsVisitsSectionChartsReasonsForIncompleteVisits />
          </ReportsVisitsSectionChartsSubContainer>

          <ReportsVisitsSectionChartsHistoricalDemandForRoutedOrders />
        </>
      )}
    </ReportsVisitsSectionChartsContainer>
  );
};

export default ReportsVisitsSectionCharts;
